import React from 'react';
import { Section } from './ui/Section';
export function MechanismSection() {
  return <>
      <Section data-id="element-84">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#faf6f0] mb-8" data-id="element-85">
          The Unique Mechanism: <br data-id="element-86" />
          <span className="text-[#c9a96e]" data-id="element-87">
            Boil-to-Bassinet Ladder + Transfer Window
          </span>
        </h2>
        <div className="space-y-8 text-lg md:text-xl text-[#f5f0e8] leading-relaxed" data-id="element-88">
          <p data-id="element-89">Here's the shift:</p>

          <div className="bg-[#1a1a2e] p-6 rounded-lg border border-[#c97a7a]/20" data-id="element-90">
            <p className="text-[#c97a7a] font-bold mb-2 text-sm uppercase tracking-wider" data-id="element-91">
              Most Parents Do Random Attempts
            </p>
            <p className="font-mono text-sm md:text-base text-[#d4cfc5]" data-id="element-92">
              Soothe → transfer → fail → panic → change 5 things → fail → doom
              scroll
            </p>
          </div>

          <div className="bg-[#1a1a2e] p-6 rounded-lg border border-[#8fae8b]/20" data-id="element-93">
            <p className="text-[#8fae8b] font-bold mb-2 text-sm uppercase tracking-wider" data-id="element-94">
              This Protocol Does
            </p>
            <p className="font-mono text-sm md:text-base text-[#d4cfc5]" data-id="element-95">
              Setup → downshift → depth check → transfer → hold-down → fade-out
              → evaluate → one change → repeat
            </p>
          </div>

          <p data-id="element-96">
            So even when it fails, you're not "back to zero." You're collecting
            data and moving up the ladder.
          </p>
        </div>
      </Section>

      <Section data-id="element-97">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#faf6f0] mb-8" data-id="element-98">
          What changes (fast)
        </h2>
        <div className="space-y-6 text-lg md:text-xl text-[#f5f0e8] leading-relaxed" data-id="element-99">
          <p data-id="element-100">Not your baby's personality. Your night.</p>
          <p data-id="element-101">Because you'll finally have:</p>
          <ul className="space-y-4" data-id="element-102">
            <li className="flex items-start" data-id="element-103">
              <span className="text-[#b8a9c9] mr-3" data-id="element-104">•</span>
              <span data-id="element-105">
                <strong className="text-[#faf6f0]" data-id="element-106">A limit</strong> (so you
                don't do 12 full transfers and become unsafe)
              </span>
            </li>
            <li className="flex items-start" data-id="element-107">
              <span className="text-[#b8a9c9] mr-3" data-id="element-108">•</span>
              <span data-id="element-109">
                <strong className="text-[#faf6f0]" data-id="element-110">A reset rung</strong> (what
                to do when exhaustion becomes dangerous)
              </span>
            </li>
            <li className="flex items-start" data-id="element-111">
              <span className="text-[#b8a9c9] mr-3" data-id="element-112">•</span>
              <span data-id="element-113">
                <strong className="text-[#faf6f0]" data-id="element-114">A micro-win mode</strong>{' '}
                (how to stack 10–20 minute bassinet stretches into longer
                stretches)
              </span>
            </li>
            <li className="flex items-start" data-id="element-115">
              <span className="text-[#b8a9c9] mr-3" data-id="element-116">•</span>
              <span data-id="element-117">
                <strong className="text-[#faf6f0]" data-id="element-118">An explanation</strong> for
                why the wake happened (instant vs 5 minutes vs 30 minutes =
                different problem)
              </span>
            </li>
          </ul>
        </div>
      </Section>
    </>;
}